import { render, staticRenderFns } from "./team-players-list.vue?vue&type=template&id=50fb066a&scoped=true&"
import script from "./team-players-list.vue?vue&type=script&lang=js&"
export * from "./team-players-list.vue?vue&type=script&lang=js&"
import style0 from "./team-players-list.vue?vue&type=style&index=0&id=50fb066a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb066a",
  null
  
)

export default component.exports